<template>
  <section class="d-flex flex-column px-5 pt-3">
    <b-input-group class="mb-2">
      <b-input-group-text slot="prepend">
        <img
          v-b-tooltip.hover
          :alt="$t('UserProfile.Demographic.FirstName')"
          :title="$t('UserProfile.Demographic.FirstName')"
          height="24"
          src="@/assets/icons/id-card.svg"
        >
      </b-input-group-text>
      <b-form-input v-model="model.FirstName" :placeholder="$t('UserProfile.Demographic.FirstName')" />
    </b-input-group>
    <b-input-group class="mb-2">
      <b-input-group-text slot="prepend">
        <img
          v-b-tooltip.hover
          :alt="$t('UserProfile.Demographic.LastName')"
          :title="$t('UserProfile.Demographic.LastName')"
          height="24"
          src="@/assets/icons/id-card.svg"
        >
      </b-input-group-text>
      <b-form-input v-model="model.LastName" :placeholder="$t('UserProfile.Demographic.LastName')" />
    </b-input-group>
    <b-input-group class="mb-2">
      <b-input-group-text slot="prepend">
        <img
          v-b-tooltip.hover
          :alt="$t('UserProfile.Demographic.DateOfBirth')"
          :title="$t('UserProfile.Demographic.DateOfBirth')"
          height="24"
          src="@/assets/icons/DOB.svg"
        >
      </b-input-group-text>
      <Datepicker v-model="model.DateOfBirth" class="datepicker"  :options="datepickerOptions" />
    </b-input-group>

    <b-input-group class="mb-2">
      <b-input-group-text slot="prepend">
        <img
          v-b-tooltip.hover
          :alt="$t('UserProfile.Demographic.Gender')"
          :title="$t('UserProfile.Demographic.Gender')"
          height="24"
          src="@/assets/icons/gender.svg"
        >
      </b-input-group-text>
      <b-form-select v-model="model.Gender" class="rounded-left">
        <option :value="$t('common.male')">
          {{ $t('common.male') }}
        </option>
        <option :value="$t('common.female')">
          {{ $t('common.female') }}
        </option>
      </b-form-select>
    </b-input-group>

    <b-input-group class="mb-2">
      <b-form-textarea
        v-model="model.Biography"
        rows="5"
        :placeholder="$t('UserProfile.Demographic.Biography')"
      />
    </b-input-group>

    <div class="d-flex flex-row justify-content-end my-2">
      <a
        class="text-decoration-none text-dark align-self-start align-content-center my-2 mx-4 "
        @click="HideEditForm()"
      >
        <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
        {{ $t('common.cancel') }}
      </a>

      <b-button
        variant="success"
        class="px-5"
        type="submit"
        @click="editUserInfo"
      >
        {{ $t('UserProfile.Commands.SubmitChanges') }}
      </b-button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import persianDate from 'persian-date'
import Datepicker from '@/components/Datepicker'
export default {
  name: 'UserProfileEditDemographic',
  components: {
    Datepicker
  },
  props: {
    user: Object
  },
  data () {
    return {
      datepickerOptions: { 
        minDate: new persianDate().subtract('year', 100).valueOf() ,
        maxDate: new Date().valueOf(),
        viewMode: 'day',
      },
      // FullName: '',
      model: {
        FullName: this.FullName,
        DateOfBirth: this.user.DateOfBirth ? this.user.DateOfBirth : new Date(),
        Gender: this.user.Gender,
        Biography: this.user.Biography
      }
    }
  },
  methods: {
    ...mapActions({
      updateUserInfo: 'userDemographic/updateUserInfo'
    }),
    HideEditForm () {
      this.$emit('HideEditForm')
    },
    editUserInfo () {
      let input = {
        firstName: this.model.FirstName ? this.model.FirstName.trim():'',
        lastName: this.model.LastName ? this.model.LastName.trim():'',
        birthDate: this.model.DateOfBirth,
        gender: this.model.Gender == this.$t('common.male'),
        bio: this.model.Biography
      }

      this.updateUserInfo(input)
        .then(response => {
          this.HideEditForm()
        })
        .catch(response => {})
    }
  },
  created () {
    this.model = {
      FullName: this.user.FirstName + ' ' + this.user.LastName,
      FirstName: this.user.FirstName,
      LastName: this.user.LastName,
      DateOfBirth: this.user.DateOfBirth ? this.user.DateOfBirth : new Date(),
      Gender: this.user.Gender,
      Biography: this.user.Biography
    }
  },
  mounted () {
    this.model = {
      FullName: this.user.FirstName + ' ' + this.user.LastName,
      FirstName: this.user.FirstName,
      LastName: this.user.LastName,
      DateOfBirth: this.user.DateOfBirth ? this.user.DateOfBirth : new Date(),
      Gender: this.user.Gender,
      Biography: this.user.Biography
    }
  }

}
</script>
